import { UseFormSetError } from "react-hook-form";

import CampaignForm, { CampaignFormContentData } from "./CampaignForm";

import { AddCampaignRequest } from "@/types/request/AddCampaignRequest";
import { UpdateCampaignRequest } from "@/types/request/UpdateCampaignRequest";

type AddCampaignFormProps = {
  clientId?: string;
  isSubmitting: boolean;
  onSubmitForm: (
    payload: AddCampaignRequest,
    setError?: UseFormSetError<CampaignFormContentData>
  ) => void;
  onSuccess?: () => void;
};

const AddCampaignForm: React.FC<AddCampaignFormProps> = ({
  clientId,
  isSubmitting,
  onSubmitForm,
  onSuccess,
}) => {
  const handleSubmit = (
    payload: UpdateCampaignRequest | AddCampaignRequest,
    setError?: UseFormSetError<CampaignFormContentData>
  ) => {
    // We know this will always be AddCampaignRequest since this is the add form
    onSubmitForm(payload as AddCampaignRequest, setError);
  };

  return (
    <CampaignForm
      type="create"
      clientId={clientId}
      isSubmitting={isSubmitting}
      onSubmitForm={handleSubmit}
      onSuccess={onSuccess}
    />
  );
};

export default AddCampaignForm;
